import React from "react";
import { cn } from "@/lib/utils";

const Container = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return <div className={cn("mx-auto w-full max-w-[1200px] px-5 sm:px-8", className)}>{children}</div>;
};

export default Container;
